<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterInstallationAcceptance"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('serialnumber_acceptance_number')"
              v-model="filterInstallationAcceptance.AcceptanceNumber"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterInstallationAcceptance.LicensePlate"
            ></v-text-field>
          </v-col>
          <v-col v-show="$vuetify.breakpoint.mdAndUp">
            <v-autocomplete
              :items="maintenanceEngineers"
              item-text="NickName"
              item-value="UserName"
              :label="$t('installation_notice_engineer')"
              v-model="filterInstallationAcceptance.MaintenanceEngineers"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              chips
              small-chips
              multiple
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="allSpecialNeedList"
              item-text="Name"
              item-value="Id"
              :label="$t('quotation_special_need')"
              v-model="filterInstallationAcceptance.SpecialNeedId"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <date-picker
              :dateName="'installation_acceptance_start_done_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setStartDoneTime"
            />
          </v-col>
          <v-col>
            <date-picker
              :dateName="'installation_acceptance_end_done_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setEndDoneTime"
            />
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getInstallationAcceptance">
              {{ $t('quotation_item_new_install_search') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="installationAcceptanceDataTableHeaders"
      :items="installationAcceptanceList"
      class="elevation-1 my-5"
      :loading="isInstallationAcceptanceLoading"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('installation_acceptance_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditInstallationAcceptanceDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('installation_acceptance_card_title') }}</span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-dialog v-model="isShowBackDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        :disabled="editedInstallationAcceptance.IsAccept"
                        class="mx-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('installation_acceptance_back') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        {{ $t('installation_acceptance_back_reason_message') }}
                      </v-card-title>
                      <v-card-text>
                        <v-textarea
                          outlined
                          v-model="backReason"
                          :label="$t('installation_acceptance_back_reason')"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowBackDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isBack">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedInstallationAcceptance.IsDone ||
                        editedInstallationAcceptance.IsTrack ||
                        editedInstallationAcceptance.IsAcceptance
                    "
                    @click="isTrack"
                    class="mx-2"
                  >
                    {{ $t('installation_acceptance_track_btn') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedInstallationAcceptance.IsDone ||
                        editedInstallationAcceptance.IsAcceptance
                    "
                    @click="isAcceptanceBtn"
                    class="mx-2"
                  >
                    {{ $t('installation_acceptance_is_acceptance') }}
                  </v-btn>
                  <div>
                    <v-btn
                      color="primary"
                      class="mx-2"
                      :disabled="
                        !editedInstallationAcceptance.IsAcceptance ||
                          !isNeedToThrowSale ||
                          editedInstallationAcceptance.IsThrowToERPSale
                      "
                      @click="transferToErpSale"
                      :loading="isLoadingSaveBtn"
                    >
                      {{ $t('installation_acceptance_is_throw') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mx-2"
                      @click="throwResume"
                      :disabled="
                        !editedInstallationAcceptance.IsAcceptance ||
                          isNeedToThrowSale ||
                          editedInstallationAcceptance.IsThrowToResume
                      "
                    >
                      {{ $t('installation_acceptance_throw_resume') }}
                    </v-btn>
                  </div>
                  <!-- <v-btn
                    color="primary"
                    class="mx-2"
                    :disabled="
                      !editedInstallationAcceptance.IsAcceptance ||
                        isNeedToThrowSale ||
                        editedInstallationAcceptance.IsThrowToMonth
                    "
                    @click="throwMonth"
                  >
                    {{ $t('installation_acceptance_throw_month_return') }}
                  </v-btn> -->
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    multiple="multiple"
                    @change="uploadPhoto"
                  />
                  <!-- multiple="multiple" -->
                  <v-btn fab text small color="primary" @click="openFileDialog">
                    <!-- :disabled="editedInstallationAcceptance.IsDone" -->
                    <v-icon>
                      mdi-paperclip
                    </v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div
                    style="color:red; margin-right:100px"
                    v-if="!editedInstallationAcceptance.IsAccept"
                  >
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ $t('installation_acceptance_status_is_accept') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="
                      editedInstallationAcceptance.IsAccept && !editedInstallationAcceptance.IsDone
                    "
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_accept') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="
                      editedInstallationAcceptance.IsDone &&
                        !editedInstallationAcceptance.IsTrack &&
                        !editedInstallationAcceptance.IsAcceptance
                    "
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_done') }}
                  </div>
                  <div
                    style="color:cornflowerblue; margin-right:100px"
                    v-if="
                      editedInstallationAcceptance.IsTrack &&
                        !editedInstallationAcceptance.IsAcceptance
                    "
                  >
                    <v-icon color="blue">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_track') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="
                      editedInstallationAcceptance.IsAcceptance &&
                        !editedInstallationAcceptance.IsThrowToERPSale &&
                        !editedInstallationAcceptance.IsThrowToResume
                    "
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_acceptance') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="
                      editedInstallationAcceptance.IsThrowToERPSale &&
                        !editedInstallationAcceptance.IsThrowToResume
                    "
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_throw') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedInstallationAcceptance.IsThrowToResume"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_throw_resume_status') }}
                  </div>
                </v-row>
              </v-card-text>
              <v-tabs v-model="tab">
                <v-tab href="#tab-1">{{ $t('app_install_acceptance') }}</v-tab>
                <v-tab
                  href="#tab-2"
                  v-if="
                    editedInstallationAcceptance.FileNameList &&
                      editedInstallationAcceptance.FileNameList.length > 0
                  "
                >
                  {{ $t('installation_acceptance_engineer_photo') }}
                </v-tab>
                <v-tab
                  href="#tab-3"
                  v-if="
                    (editedInstallationAcceptance.NoticeType === noticeType.TryInstall ||
                      editedInstallationAcceptance.NoticeType === noticeType.AutoMakeTryInstall) &&
                      !editedInstallationAcceptance.OriginalTryInstallNumber &&
                      editedInstallationAcceptance.IsThrowToERPSale
                  "
                >
                  驗收單劃分單據
                </v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="computedNoticeType"
                              label="單別"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.Number"
                              :label="$t('serialnumber_acceptance_number')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnNoticeToAcceptanceDate"
                              :label="$t('installation_notice_create_time')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.CustomerNumber"
                              :label="$t('quotation_customer_number')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.CustomerName"
                              :label="$t('quotation_shortname')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.CustomerFullName"
                              :label="$t('quotation_full_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.CarPlace"
                              :label="$t('quotation_car_place')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-autocomplete
                              :items="allSpecialNeedList"
                              item-text="Name"
                              item-value="Name"
                              :label="$t('quotation_special_need')"
                              disabled
                              v-model="editedInstallationAcceptance.SpecialNeedList"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              small-chips
                              multiple
                              return-object
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.Brand"
                              disabled
                              label="廠牌/車型"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_first_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.FirstContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.FirstContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_second_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.SecondContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.SecondContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_third_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.ThirdContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedInstallationAcceptance.ThirdContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <ValidationObserver ref="dialogeditedInstallationAcceptance">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationAcceptance.LicensePlate"
                                :label="$t('quotation_license_plate')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationAcceptance.OriginalLicensePlate"
                                :label="$t('quotation_original_license_plate')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_engineer')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-autocomplete
                                  :items="maintenanceEngineers"
                                  item-text="NickName"
                                  item-value="UserName"
                                  :label="$t('installation_notice_engineer')"
                                  v-model="editedInstallationAcceptance.MaintenanceEngineers"
                                  :error-messages="errors[0]"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :disabled="
                                    !editedInstallationAcceptance.IsAccept ||
                                      editedInstallationAcceptance.IsDone
                                  "
                                  chips
                                  small-chips
                                  multiple
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_point')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationAcceptance.Point"
                                  :label="$t('installation_notice_point')"
                                  disabled
                                  :error-messages="errors[0]"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_else_point')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationAcceptance.ElsePoint"
                                  :label="$t('installation_notice_else_point')"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedInstallationAcceptance.IsAcceptance ||
                                      !editedInstallationAcceptance.IsDone
                                  "
                                  @keyup.enter="focusNextInput"
                                  :error-messages="errors[0]"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_else_point_reason')"
                                v-if="editedInstallationAcceptance.ElsePoint != 0"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedInstallationAcceptance.ElsePointReason"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedInstallationAcceptance.IsAcceptance ||
                                      !editedInstallationAcceptance.IsDone
                                  "
                                  :error-messages="errors[0]"
                                  v-if="editedInstallationAcceptance.ElsePoint != 0"
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_else_point_reason') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationAcceptance.SaleNumber"
                                :label="$t('installation_notice_sale_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationAcceptance.SaleName"
                                :label="$t('installation_notice_sale_name')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedInstallationAcceptance.NoticeNumber"
                                :label="$t('installation_acceptance_notice_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnNoticeToAcceptanceBy"
                                :label="$t('installation_acceptance_notice_throw_by')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnDoneTime"
                                :label="$t('installation_acceptance_done_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnAcceptanceTime"
                                :label="$t('installation_acceptance_acceptance_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-select
                                v-model="editedInstallationAcceptance.TrackBy"
                                :items="tracks"
                                :label="$t('installation_acceptance_track_by')"
                                clearable
                                :disabled="
                                  isAllTextFieldDisable ||
                                    editedInstallationAcceptance.IsAcceptance ||
                                    !editedInstallationAcceptance.IsDone ||
                                    editedInstallationAcceptance.IsTrack
                                "
                                @keyup.enter="setTrackByAutocomplete"
                                ref="trackByAutocomplete"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="getLastThrowName"
                              :label="$t('installation_acceptance_throw_by')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="getLastThrowTime"
                              :label="$t('installation_acceptance_throw_time')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            editedInstallationAcceptance.NoticeType == noticeType.TryInstall &&
                              editedInstallationAcceptance.IsThrowInstallOrRemove
                          "
                        >
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                            xl="3"
                            v-if="editedInstallationAcceptance.InstallNumber"
                          >
                            <v-text-field
                              v-model="editedInstallationAcceptance.InstallNumber"
                              label="安裝單單號"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            lg="3"
                            xl="3"
                            v-if="editedInstallationAcceptance.RemoveNumber"
                          >
                            <v-text-field
                              v-model="editedInstallationAcceptance.RemoveNumber"
                              label="拆機單單號"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              v-model="editedInstallationAcceptance.Remark"
                              label="派單備註"
                              :disabled="isAllTextFieldDisable"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-tabs>
                      <v-tab href="#tab-1">Not Exist</v-tab>
                      <v-tab
                        href="#tab-2"
                        v-if="editedInstallationAcceptance.InResumeItems.length !== 0"
                      >
                        Exist
                      </v-tab>
                      <v-spacer></v-spacer>
                      <add-acceptance-item
                        :isAllTextFieldDisable="isAllTextFieldDisable"
                        :isAcceptance="editedInstallationAcceptance.IsAcceptance"
                        :isDone="editedInstallationAcceptance.IsDone"
                        @setAddAcceptanceItem="setAddAcceptanceItem"
                      />
                      <v-tab-item value="tab-1">
                        <v-card flat>
                          <acceptance-item-not-in-resume
                            :titleName="'acceptance_item_not_in_resume_title'"
                            :acceptanceItems="editedInstallationAcceptance.NotInResumeItems"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            :isAcceptance="editedInstallationAcceptance.IsAcceptance"
                            :isDone="editedInstallationAcceptance.IsDone"
                            @setEditedAcceptanceItemIndex="setEditedAcceptanceItemIndex"
                            @setEditedAcceptanceItem="setEditedNotExistAcceptanceItem"
                            @setDeleteItem="setDeleteNotExistAcceptanceItem"
                            @setItemIsNeedThrowResume="setItemIsNeedThrowResume"
                          />
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="tab-2">
                        <v-card flat>
                          <acceptance-item-in-resume
                            :titleName="'acceptance_item_in_resume_title'"
                            :acceptanceItems="editedInstallationAcceptance.InResumeItems"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            :isAcceptance="editedInstallationAcceptance.IsAcceptance"
                            :isDone="editedInstallationAcceptance.IsDone"
                            @setEditedAcceptanceItemIndex="setEditedAcceptanceItemIndex"
                            @setEditedAcceptanceItem="setEditedExistAcceptanceItem"
                            @setDeleteItem="setDeleteExistAcceptanceItem"
                          />
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-row>
                    <v-col
                      cols="2"
                      v-for="(acceptanceImage, index) in acceptanceImageList"
                      :key="acceptanceImage"
                    >
                      <v-card flat>
                        <v-img :src="acceptanceImage"></v-img>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="deletePhoto(index)">{{
                            $t('common_delete')
                          }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <select-divide-item
                    :editedInstallationAcceptance="editedInstallationAcceptance"
                    :tab="tab"
                    @searchEditedAcceptance="searchEditedAcceptance"
                  />
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedInstallationAcceptance"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_close') }}
                </v-btn>
                <!-- <v-btn
                        color="blue darken-1"
                        text
                        @click="saveEditedInstallationAcceptance"
                        :loading="isLoadingSaveBtn"
                        :disabled="!editedInstallationAcceptance.IsAccept || editedInstallationAcceptance.IsDone"
                        >
                        {{ $t("common_save") }}
                        </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditInstallationAcceptanceDialogBtn(item)">
          <v-icon :small="$vuetify.breakpoint.mdAndUp">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ methodsStatus(item) }}
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
      <template v-slot:[`item.NoticeType`]="{ item }">
        {{ turnNoticeType(item.NoticeType) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'

import {
  HttpInstallationAcceptance,
  HttpInstallationNotice,
  HttpUser,
  HttpSpecialNeed,
  HttpSerialNumber
} from '@/js/http-Manager'

import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePicker from '@/components/DatePicker.vue'
import AcceptanceItemInResume from '@/components/Acceptance/AcceptanceItemInResume.vue'
import AcceptanceItemNotInResume from '@/components/Acceptance/AcceptanceItemNotInResume.vue'
import { NoticeType } from '@/js/NoticeType'
import SelectDivideItem from '@/components/Acceptance/SelectDivideItem.vue'
import AddAcceptanceItem from '../components/Acceptance/AddAcceptanceItem.vue'

extend('regex', regex)
export default {
  components: {
    CustomerAutocompleteFilter,
    DatePicker,
    AcceptanceItemInResume,
    AcceptanceItemNotInResume,
    SelectDivideItem,
    AddAcceptanceItem
  },
  name: 'InstallationAcceptance',
  data: () => ({
    noticeType: NoticeType,
    isShowEditInstallationAcceptanceDialog: false,
    installationAcceptanceList: [],
    editedInstallationAcceptanceIndex: -1,
    editedInstallationAcceptance: {
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      SaleNumber: '',
      SaleName: '',
      NoticeType: 0,
      NoticeNumber: '',
      LicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineers: [],
      IsAccept: false,
      IsDone: false,
      DoneTime: 0,
      TrackBy: '',
      IsTrack: false,
      IsAcceptance: false,
      AcceptanceTime: 0,
      IsThrowToERPSale: false,
      NoticeToAcceptanceThrowUsers: {
        ThrowTime: 0,
        Name: ''
      },
      InstallationAcceptanceItems: [],
      InResumeItems: [],
      NotInResumeItems: [],
      CrmToErpThrowUsers: [],
      FileNameList: [],
      SpecialNeedList: [],
      Brand: '',
      Remark: '',
      InstallNumber: '',
      RemoveNumber: '',
      IsThrowInstallOrRemove: false
    },
    defaultInstallationAcceptance: {
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      SaleNumber: '',
      SaleName: '',
      NoticeType: 0,
      NoticeNumber: '',
      LicensePlate: '',
      Point: 0,
      ElsePointReason: '',
      ElsePoint: 0,
      MaintenanceEngineers: [],
      IsAccept: false,
      IsDone: false,
      DoneTime: 0,
      IsAcceptance: false,
      TrackBy: '',
      IsTrack: false,
      AcceptanceTime: 0,
      IsThrowToERPSale: false,
      NoticeToAcceptanceThrowUsers: {
        ThrowTime: 0,
        Name: ''
      },
      InstallationAcceptanceItems: [],
      InResumeItems: [],
      NotInResumeItems: [],
      CrmToErpThrowUsers: [],
      FileNameList: [],
      SpecialNeedList: [],
      Brand: '',
      Remark: '',
      InstallNumber: '',
      RemoveNumber: '',
      IsThrowInstallOrRemove: false
    },
    isInstallationAcceptanceLoading: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    updateInstallationAcceptanceSource: null,
    installationAcceptanceSource: null,

    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    filterInstallationAcceptance: {
      CustomerId: '',
      AcceptanceNumber: '',
      LicensePlate: '',
      MaintenanceEngineers: [],
      StartDoneTime: 0,
      EndDoneTime: 0,
      SpecialNeedId: ''
    },

    maintenanceEngineers: [],

    tracks: ['工務追', '業務追', '客服追'],
    acceptanceImageList: [],
    isShowBackDialog: false,
    backReason: '',
    allSpecialNeedList: [],
    editedAcceptanceItemIndex: -1,
    isLoading: false,
    tab: 'tab-1'
  }),
  watch: {},
  async mounted () {
    await this.countTotalRows()
    await this.getInstallationAcceptance()
    await this.getEngineerUser()
    await this.getSpecialNeedList()
  },
  computed: {
    computedNoticeType () {
      return this.turnNoticeType(this.editedInstallationAcceptance.NoticeType)
    },
    installationAcceptanceDataTableHeaders () {
      return [
        {
          text: '單別',
          align: 'start',
          value: 'NoticeType'
        },
        {
          text: this.$t('serialnumber_acceptance_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineersNickName'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('installation_notice_point'), align: 'end', value: 'Point' },
        { text: this.$t('installation_notice_else_point'), align: 'end', value: 'ElsePoint' },
        { text: this.$t('installation_acceptance_track_by'), align: 'start', value: 'TrackBy' },
        { text: this.$t('common_status'), align: 'center', value: 'Status', sortable: false },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    getLastThrowName () {
      let crmToErpThrowUsers = this.editedInstallationAcceptance.CrmToErpThrowUsers
      if (crmToErpThrowUsers.length !== 0) {
        return crmToErpThrowUsers[crmToErpThrowUsers.length - 1].Name
      }
      return ''
    },
    getLastThrowTime () {
      let crmToErpThrowUsers = this.editedInstallationAcceptance.CrmToErpThrowUsers
      if (crmToErpThrowUsers.length !== 0) {
        return this.convertToDateTimeFormat(
          crmToErpThrowUsers[crmToErpThrowUsers.length - 1].ThrowTime
        )
      }
      return 0
    },
    turnNoticeToAcceptanceDate () {
      if (this.editedInstallationAcceptance.NoticeToAcceptanceThrowUsers !== null) {
        return this.convertToDateTimeFormat(
          this.editedInstallationAcceptance.NoticeToAcceptanceThrowUsers.ThrowTime
        )
      }
      return 0
    },
    turnNoticeToAcceptanceBy () {
      if (this.editedInstallationAcceptance.NoticeToAcceptanceThrowUsers !== null) {
        return this.editedInstallationAcceptance.NoticeToAcceptanceThrowUsers.Name
      }
      return ''
    },
    turnDoneTime () {
      return this.convertToDateTimeFormat(this.editedInstallationAcceptance.DoneTime)
    },
    turnAcceptanceTime () {
      return this.convertToDateTimeFormat(this.editedInstallationAcceptance.AcceptanceTime)
    },

    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    isNeedToThrowSale () {
      let isNeedThrow = false
      if (this.editedInstallationAcceptanceIndex !== -1) {
        if (
          this.editedInstallationAcceptance.NoticeType === this.noticeType.NewInstall ||
          this.editedInstallationAcceptance.NoticeType === this.noticeType.AutoMakeNewInstall
        ) {
          // 新安裝要轉到銷貨單
          isNeedThrow = true
        } else if (
          this.editedInstallationAcceptance.NotInResumeItems.length > 0 &&
          this.editedInstallationAcceptance.NotInResumeItems.findIndex(
            (x) => (!x.IsCustomerDevice || x.Custody === 1) && x.IsNeedThrowResume
          ) !== -1
        ) {
          // 不在履歷卡，不是客戶設備、放置位置為EGK
          isNeedThrow = true
        } else if (
          this.editedInstallationAcceptance.InResumeItems.length > 0 &&
          this.editedInstallationAcceptance.InResumeItems.findIndex(
            (x) => (!x.IsCustomerDevice || x.Custody === 1) && x.IsNeedThrowResume
          ) !== -1
        ) {
          // 在履歷卡，不是客戶設備、放置位置為EGK
          isNeedThrow = true
        }
      }

      return isNeedThrow
    }
  },
  methods: {
    turnNoticeType (noticeType) {
      return NoticeType.getFormNoticeTypeName(noticeType)
    },
    setTrackByAutocomplete (event) {
      this.$refs.trackByAutocomplete.isMenuActive = false
      this.$refs.trackByAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.maintenanceEngineers = response.status === 200 ? response.data.Data : []
    },
    async isBack () {
      await HttpInstallationAcceptance.UpdateAcceptanceIsDelete(
        this.editedInstallationAcceptance.Id
      )
      await HttpInstallationNotice.IsBackAcceptance({
        number: this.editedInstallationAcceptance.NoticeNumber,
        reason: this.backReason
      })
      await this.closeEditedInstallationAcceptance()
      this.backReason = ''
    },
    async deletePhoto (index) {
      await HttpInstallationAcceptance.DeleteImage({
        acceptanceNumber: this.editedInstallationAcceptance.Number,
        fileName: this.editedInstallationAcceptance.FileNameList[index]
      })
      this.editedInstallationAcceptance.FileNameList.splice(index, 1)
      await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
      await this.getPhoto()
      await this.searchEditedAcceptance()
    },
    async getPhoto () {
      if (
        this.editedInstallationAcceptance.FileNameList &&
        this.editedInstallationAcceptance.FileNameList.length > 0
      ) {
        let response = await HttpInstallationAcceptance.GetImage({
          acceptanceNumber: this.editedInstallationAcceptance.Number,
          acceptanceFileList: this.editedInstallationAcceptance.FileNameList.join(',')
        })
        this.acceptanceImageList = response.status === 200 ? response.data.Data : []
      }
    },
    async uploadPhoto (event) {
      if (event.target.files.length > 0) {
        let formData = new FormData()
        for (var i = 0; i < event.target.files.length; i++) {
          formData.append('Files', event.target.files[i])
        }

        formData.append('Number', this.editedInstallationAcceptance.Number)

        await HttpInstallationAcceptance.UploadImage(formData)

        if (!this.editedInstallationAcceptance.FileNameList) {
          this.editedInstallationAcceptance.FileNameList = []
        }
        for (let i = 0; i < event.target.files.length; i++) {
          this.editedInstallationAcceptance.FileNameList.push(event.target.files[i].name)
        }
        await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
        await this.getPhoto()
        await this.searchEditedAcceptance()
      }
    },
    openFileDialog () {
      this.$refs.file.click()
    },
    setStartDoneTime (val) {
      this.filterInstallationAcceptance.StartDoneTime = val * 1
    },
    setEndDoneTime (val) {
      this.filterInstallationAcceptance.EndDoneTime = val * 1
    },

    async setFilterCustomer (val) {
      this.filterInstallationAcceptance.CustomerId = val.Id
      this.filterInstallationAcceptance = JSON.parse(
        JSON.stringify(this.filterInstallationAcceptance)
      )
      // await this.getInstallationAcceptance()
      // await this.countTotalRows()
    },
    async throwResume () {
      let response = await HttpInstallationAcceptance.TransferAcceptanceToResume(
        this.editedInstallationAcceptance
      )
      if (response && response.status === 200) {
        await this.searchEditedAcceptance()
        this.editedInstallationAcceptance.IsThrowToResume = true
        await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
        await this.getInstallationAcceptance()
        await this.searchEditedAcceptance()
        if (!this.isNeedToThrowSale) {
          await this.throwMonth()
        }
      }
    },
    methodsStatus (value) {
      if (!value.IsAccept) {
        return this.$t('installation_acceptance_status_is_accept')
      } else if (value.IsAccept && !value.IsDone) {
        return this.$t('installation_acceptance_status_accept')
      } else if (value.IsDone && !value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_status_done')
      } else if (value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_track_btn')
      } else if (value.IsAcceptance && !value.IsThrowToERPSale && !value.IsThrowToResume) {
        return this.$t('installation_acceptance_status_acceptance')
      } else if (value.IsThrowToERPSale && !value.IsThrowToResume) {
        return this.$t('installation_acceptance_status_throw')
      } else if (value.IsThrowToResume) {
        return this.$t('installation_acceptance_throw_resume_status')
      } else {
        return this.$t('installation_acceptance_status_is_accept')
      }
    },
    async transferToErpSale () {
      this.isLoadingSaveBtn = true
      let response = await HttpInstallationAcceptance.TransferAcceptanceSunlikeFlow(
        this.editedInstallationAcceptance
      )
      if (response && response.status === 200) {
        await this.searchEditedAcceptance()
      }
      this.isLoadingSaveBtn = false
    },
    async searchEditedAcceptance () {
      let param = {
        id: this.editedInstallationAcceptance.Id,
        number: this.editedInstallationAcceptance.Number
      }
      let response = await HttpInstallationAcceptance.SearchEditedAcceptance(param)
      this.editedInstallationAcceptance = response.status === 200 ? response.data.Data : {}
    },
    async isTrack () {
      const isValid = await this.$refs.dialogeditedInstallationAcceptance.validate()
      if (isValid) {
        this.editedInstallationAcceptance.IsTrack = true
        await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
        await this.getInstallationAcceptance()
        await this.searchEditedAcceptance()
      }
    },
    async isAcceptanceBtn () {
      this.editedInstallationAcceptance.IsAcceptance = true
      this.editedInstallationAcceptance.IsTrack = false
      this.editedInstallationAcceptance.TrackBy = ''
      await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
      await this.getInstallationAcceptance()
      await this.searchEditedAcceptance()
      await this.addNotice()
    },
    async addNotice () {
      for (
        let index = 0;
        index < this.editedInstallationAcceptance.InstallationAcceptanceItems.length;
        index++
      ) {
        const element = this.editedInstallationAcceptance.InstallationAcceptanceItems[index]
        if (element.RealQuantity === 0) {
          await HttpInstallationNotice.AddNoticeFromAcceptance(this.editedInstallationAcceptance)
          break
        }
      }
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        var maintenanceEngineers = ''
        if (this.filterInstallationAcceptance.MaintenanceEngineers.length !== 0) {
          this.filterInstallationAcceptance.MaintenanceEngineers.forEach((element, index) => {
            if (index === this.filterInstallationAcceptance.MaintenanceEngineers.length - 1) {
              maintenanceEngineers += element
            } else {
              maintenanceEngineers = maintenanceEngineers + element + ','
            }
          })
        }
        let param = {
          acceptanceNumber: this.filterInstallationAcceptance.AcceptanceNumber,
          customerId: this.filterInstallationAcceptance.CustomerId,
          licensePlate: this.filterInstallationAcceptance.LicensePlate,
          maintenanceEngineers: maintenanceEngineers,
          startDoneTime: this.filterInstallationAcceptance.StartDoneTime,
          endDoneTime: this.filterInstallationAcceptance.EndDoneTime,
          specialNeedId: this.filterInstallationAcceptance.SpecialNeedId
        }

        if (this.countTotalRowsSource) {
          this.countTotalRowsSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.countTotalRowsSource = cancelToken.source()
        let response = await HttpInstallationAcceptance.GetAcceptancesCount(
          param,
          this.countTotalRowsSource.token
        )
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getInstallationAcceptance(val)
    },
    async getInstallationAcceptance (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isInstallationAcceptanceLoading = true
      if (this.installationAcceptanceSource) {
        this.installationAcceptanceSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.installationAcceptanceSource = cancelToken.source()
      var maintenanceEngineers = ''
      if (this.filterInstallationAcceptance.MaintenanceEngineers.length !== 0) {
        this.filterInstallationAcceptance.MaintenanceEngineers.forEach((element, index) => {
          if (index === this.filterInstallationAcceptance.MaintenanceEngineers.length - 1) {
            maintenanceEngineers += element
          } else {
            maintenanceEngineers = maintenanceEngineers + element + ','
          }
        })
      }

      let param = {
        acceptanceNumber: this.filterInstallationAcceptance.AcceptanceNumber,
        customerId: this.filterInstallationAcceptance.CustomerId,
        licensePlate: this.filterInstallationAcceptance.LicensePlate,
        maintenanceEngineers: maintenanceEngineers,
        startDoneTime: this.filterInstallationAcceptance.StartDoneTime,
        endDoneTime: this.filterInstallationAcceptance.EndDoneTime,
        specialNeedId: this.filterInstallationAcceptance.SpecialNeedId,
        itemsPerPage:
          typeof val === 'object' && val.itemsPerPage > 0
            ? val.itemsPerPage
            : this.currentOptions.itemsPerPage,
        page: typeof val === 'object' && val && val.page > 0 ? val.page : this.currentOptions.page,
        sortBy:
          typeof val === 'object' && val.sortBy ? val.sortBy[0] : this.currentOptions.sortBy[0],
        sortDesc:
          typeof val === 'object' && val.sortBy ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }

      let response = await HttpInstallationAcceptance.GetAcceptances(param)
      this.isInstallationAcceptanceLoading = false
      this.installationAcceptanceList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    // async saveEditedInstallationAcceptance () {
    //   // const isValid = await this.$refs.dialogeditedInstallationAcceptance.validate()
    //   // if (isValid) {
    //   this.isLoadingSaveBtn = true
    //   this.isAllTextFieldDisable = true
    //   this.isInstallationAcceptanceLoading = true
    //   await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
    //   await await this.getInstallationAcceptance()
    //   this.closeEditedInstallationAcceptance()
    //   // }
    // },
    async closeEditedInstallationAcceptance () {
      this.isShowEditInstallationAcceptanceDialog = false
      this.isInstallationAcceptanceLoading = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultInstallationAcceptance)
        this.editedInstallationAcceptance = JSON.parse(str)
        this.editedInstallationAcceptanceIndex = -1
      })
      await this.getInstallationAcceptance()
    },
    async isShowEditInstallationAcceptanceDialogBtn (item) {
      this.editedInstallationAcceptanceIndex = this.installationAcceptanceList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedInstallationAcceptance = JSON.parse(str)
      await this.getPhoto()
      this.isShowEditInstallationAcceptanceDialog = true
    },
    async throwMonth () {
      await HttpInstallationAcceptance.TransferAcceptanceToMonth(this.editedInstallationAcceptance)
      await this.getInstallationAcceptance()
      await this.searchEditedAcceptance()
    },
    setEditedAcceptanceItemIndex (val) {
      this.editedAcceptanceItemIndex = val
    },
    setEditedNotExistAcceptanceItem (val) {
      if (this.editedAcceptanceItemIndex > -1) {
        this.editedInstallationAcceptance.NotInResumeItems.splice(
          this.editedAcceptanceItemIndex,
          1,
          val
        )
      } else {
        this.editedInstallationAcceptance.NotInResumeItems.push(val)
      }
    },
    setEditedExistAcceptanceItem (val) {
      if (this.editedAcceptanceItemIndex > -1) {
        this.editedInstallationAcceptance.InResumeItems.splice(
          this.editedAcceptanceItemIndex,
          1,
          val
        )
      } else {
        this.editedInstallationAcceptance.InResumeItems.push(val)
      }
    },
    async setDeleteExistAcceptanceItem (val) {
      let acceptanceItem = this.editedInstallationAcceptance.InResumeItems[val]
      if (acceptanceItem.SerialNumber && acceptanceItem.SerialNumber.Number) {
        await HttpSerialNumber.UpdateSerialNumberForIsDeleteByAcceptance(acceptanceItem)
      }
      this.editedInstallationAcceptance.InResumeItems.splice(val, 1)
      await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
      await this.getInstallationAcceptance()
      await this.searchEditedAcceptance()
    },
    async setDeleteNotExistAcceptanceItem (val) {
      let acceptanceItem = this.editedInstallationAcceptance.NotInResumeItems[val]
      if (acceptanceItem.SerialNumber && acceptanceItem.SerialNumber.Number) {
        await HttpSerialNumber.UpdateSerialNumberForIsDeleteByAcceptance(acceptanceItem)
      }
      this.editedInstallationAcceptance.NotInResumeItems.splice(val, 1)
      await HttpInstallationAcceptance.UpdateAcceptance(this.editedInstallationAcceptance)
      await this.getInstallationAcceptance()
      await this.searchEditedAcceptance()
    },
    setItemIsNeedThrowResume (notThrowList) {
      this.editedInstallationAcceptance.NotInResumeItems.forEach((element, index) => {
        let isExist = notThrowList.findIndex((x) => x.Index === index) === -1
        element.IsNeedThrowResume = isExist
      })
      this.editedInstallationAcceptance.NotInResumeItems = JSON.parse(
        JSON.stringify(this.editedInstallationAcceptance.NotInResumeItems)
      )
    },
    async setAddAcceptanceItem (val) {
      let param = {
        InstallationAcceptanceItem: val,
        Number: this.editedInstallationAcceptance.Number,
        CustomerId: this.editedInstallationAcceptance.CustomerId
      }
      let snResponse = await HttpSerialNumber.UpdateSerialNumberForIsDoneByAcceptance(param)
      if (snResponse && snResponse.status === 200) {
        let updateResponse = await HttpInstallationAcceptance.UpdateAcceptanceItem(param)
        if (updateResponse && updateResponse.status === 200) {
          await this.getInstallationAcceptance()
          await this.searchEditedAcceptance()
        }
      }
    }
  }
}
</script>
